import { NumberInput, tryParseJSONObject } from "@fox/atoms";
import React from "react";
import { CustomFieldEditProps } from "../contracts";

interface INumberMeta {
	disableNegative?: boolean;
	disableFloat?: boolean;
	min?: number;
	max?: number;
}

export const NumberCustomField: React.FC<CustomFieldEditProps> = ({ customField, onChange }) => {
	const meta = tryParseJSONObject<INumberMeta>(customField.meta);
	return (
		<NumberInput
			value={customField.value ? Number(customField.value) : ""}
			label={customField.displayName}
			max={meta.max}
			min={meta.disableNegative ? 0 : meta.min}
			onChange={(value) => onChange(customField.customFieldId, value)}
			onKeyDown={(e) => {
				if (meta.disableNegative && e.keyCode === 189) {
					e.preventDefault();
				}
				if (meta.disableFloat && e.keyCode === 190) {
					e.preventDefault();
				}
			}}
		/>
	);
};
